import { Pipe, PipeTransform, inject } from '@angular/core';
import { SessionService } from '../services/session.service';
import * as moment from "moment";
import "moment-timezone";


@Pipe({
    name: 'dateMoment',
    standalone: true
})
export class DateMomentPipe implements PipeTransform {
  private _sessionSrv = inject(SessionService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  public transform(value: any, args?: Array<any>): any {
    if (value) {
      const arg = args ? args[0] : {};
      const { timezone, format, locale } = arg;
      const tz = timezone ? timezone : this._sessionSrv.getTimezone;
      const fmt = format ? format : "L";
      const lan = locale ? locale : this._sessionSrv.getLanguage;

      let time = moment.tz(value, tz).locale(lan).format(fmt);
      return time.toString();
    }
    return "";
  }
}
